import { common } from '../common.js';
import type { IProgram } from '../types.js';

/** Ontario Immigrant Nominee Program: Ontario Workforce Priority stream (the nomination application to Ontario). */
export const OINP_WORKFORCE_PRIORITY: IProgram = {
  id: 'oinp-workforce-priority',
  name: 'Ontario Immigrant Nominee Program: Ontario Workforce Priority stream (nomination)',
  short: 'OINP nomination',
  family: 'economic',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'Ontario: Ontario Workforce Priority stream', url: 'https://www.ontario.ca/page/ontario-workforce-priority-stream', retrieved: '2026-10-04' },
    { title: 'Ontario: Ontario Immigrant Nominee Program', url: 'https://www.ontario.ca/page/ontario-immigrant-nominee-program-oinp', retrieved: '2026-10-04' }
  ],
  questions: [
    { id: 'physician', text: 'Is the applicant a self-employed physician (no job offer)?', kind: 'yesno' },
    { id: 'licence', text: 'Does the job need a licence or other authorization in Ontario?', kind: 'yesno' },
    { id: 'recentGraduate', text: 'Is the applicant a recent Ontario graduate?', kind: 'yesno' }
  ],
  roles: [{ id: 'principal', label: 'Applicant', min: 1, max: 1 }],
  sections: ['Forms', 'Employer and job', 'Experience, language and education', 'Identity and civil documents', 'Fees'],
  items: [
    { id: 'invitation', label: 'Invitation to apply (from the expression of interest)', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'oinpChecklist', label: 'OINP document checklist for the stream, filled in', section: 'Forms', forRoles: 'application', source: 1 },
    { id: 'representative', label: 'OINP representative form (the province\'s own)', section: 'Forms', forRoles: 'application', source: 1 },
    { id: 'employerApproval', label: 'Employer\'s application for approval of the employment position (Employer Portal), and its number', section: 'Employer and job', forRoles: 'application', when: { not: { q: 'physician', is: true } }, source: 0 },
    { id: 'jobOffer', label: 'Job offer', section: 'Employer and job', forRoles: ['principal'], when: { not: { q: 'physician', is: true } }, source: 0 },
    { id: 'licence', label: 'Valid licence or other authorization for the job', section: 'Employer and job', forRoles: ['principal'], when: { q: 'licence', is: true }, source: 0 },
    { id: 'experience', label: 'Proof of the work experience the TEER category requires (employer letters, pay records)', section: 'Experience, language and education', forRoles: ['principal'], source: 0 },
    { id: 'graduation', label: 'Proof of graduating from an eligible Ontario institution within the last 3 years', section: 'Experience, language and education', forRoles: ['principal'], when: { q: 'recentGraduate', is: true }, source: 0 },
    { id: 'language', label: 'Language test results', section: 'Experience, language and education', forRoles: ['principal'], source: 0 },
    { id: 'education', label: 'Proof of education (and an educational credential assessment if studied outside Canada)', section: 'Experience, language and education', forRoles: ['principal'], source: 0 },
    { id: 'eoiFactors', label: 'Documents supporting each scoring factor claimed in the expression of interest', section: 'Experience, language and education', forRoles: ['principal'], source: 0 },
    common.passport(0, ['principal']),
    { id: 'status', label: 'Proof of legal status in Canada (if in Canada)', section: 'Identity and civil documents', forRoles: ['principal'], source: 0 },
    { id: 'fees', label: 'Proof of payment of the OINP fee', section: 'Fees', forRoles: 'application', source: 1 }
  ],
  deadlines: []
};

/** Permanent residence after a provincial nomination, outside Express Entry. */
export const PNP_PERMANENT_RESIDENCE: IProgram = {
  id: 'pnp-permanent-residence',
  name: 'Provincial Nominee Program: permanent residence application (outside Express Entry)',
  short: 'PNP permanent residence',
  family: 'economic',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'IRCC: Provincial Nominee Program, non-Express Entry', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/provincial-nominees/non-express-entry.html', retrieved: '2026-10-04' }
  ],
  questions: [],
  roles: [
    { id: 'principal', label: 'Nominee', min: 1, max: 1 },
    { id: 'spouse', label: 'Spouse or common-law partner', min: 0, max: 1 },
    { id: 'dependant', label: 'Dependent child', min: 0, max: 15 }
  ],
  sections: ['Forms', 'Nomination', 'Identity and civil documents', 'Photos and police certificates', 'Fees'],
  items: [
    { id: 'personalChecklist', label: 'IRCC document checklist (from the PR portal), filled in', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'imm0008', label: 'Generic Application Form for Canada (online)', form: 'IMM 0008', section: 'Forms', forRoles: ['principal'], source: 0 },
    { id: 'imm5669', label: 'Schedule A, Background/Declaration (online)', form: 'IMM 5669', section: 'Forms', forRoles: ['principal', 'spouse', 'dependant'], minAge: 18, source: 0 },
    { id: 'imm5406', label: 'Additional Family Information (online)', form: 'IMM 5406', section: 'Forms', forRoles: ['principal', 'spouse', 'dependant'], minAge: 18, source: 0 },
    common.representative(0),
    { id: 'nomination', label: 'Provincial nomination certificate', section: 'Nomination', forRoles: ['principal'], source: 0 },
    common.passport(0, ['principal', 'spouse', 'dependant']),
    common.birth(0, ['principal', 'spouse', 'dependant']),
    common.photos(0, ['principal', 'spouse', 'dependant']),
    common.police(0, ['principal', 'spouse', 'dependant']),
    common.translations(0),
    common.fees(0)
  ],
  deadlines: []
};
